(function () {
  function pad2(n) {
    return String(Math.max(0, Math.floor(n))).padStart(2, '0');
  }

  function getCampaignTargetMs(rawDate) {
    if (rawDate) {
      var parsed = new Date(rawDate).getTime();
      if (!Number.isNaN(parsed) && parsed > Date.now()) return parsed;
    }
    // Same campaign rule as top bar: day 11, 23:59:59, rolling to next month.
    var now = new Date();
    var target = new Date(now.getFullYear(), now.getMonth(), 11, 23, 59, 59, 0);
    if (now.getTime() > target.getTime()) {
      target = new Date(now.getFullYear(), now.getMonth() + 1, 11, 23, 59, 59, 0);
    }
    return target.getTime();
  }

  function tickEl(el) {
    var targetDateRaw = el.getAttribute('data-target-date');
    var targetMs = getCampaignTargetMs(targetDateRaw);

    var remMs = targetMs - Date.now();
    if (remMs < 0) remMs = 0;

    var dayMs = 24 * 60 * 60 * 1000;
    var hourMs = 60 * 60 * 1000;
    var minuteMs = 60 * 1000;
    var secondMs = 1000;

    var d = Math.floor(remMs / dayMs);
    var h = Math.floor((remMs % dayMs) / hourMs);
    var m = Math.floor((remMs % hourMs) / minuteMs);
    var s = Math.floor((remMs % minuteMs) / secondMs);
    var ms = remMs % secondMs;

    var dN = el.querySelector('[data-uc-d]');
    var hN = el.querySelector('[data-uc-h]');
    var mN = el.querySelector('[data-uc-m]');
    var sN = el.querySelector('[data-uc-s]');
    var msN = el.querySelector('[data-uc-ms]');
    if (dN) dN.textContent = pad2(d);
    if (hN) hN.textContent = pad2(h);
    if (mN) mN.textContent = pad2(m);
    if (sN) sN.textContent = pad2(s);
    if (msN) msN.textContent = String(ms).padStart(3, '0');
  }

  function tickAll() {
    document.querySelectorAll('[data-urgency-countdown]').forEach(tickEl);
  }

  function run() {
    tickAll();
    setInterval(tickAll, 10);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
